module.exports = __webpack_public_path__ + "media/src/assets/Images/Schedule-c96234c3b3c65b98913fe61a0da5afea.svg";